import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "clear",
    description: "Clears command output",
    options: [],
    arguments: [],
    callback: writer => {
        writer.clear();
        return { input: "" };
    }
} as ICLICommand;
